import React, { useEffect } from 'react'
import Navbar from '../../components/common/Navbar/Navbar'
import Footer from '../../components/common/Footer/Footer'
import Bannar from '../../components/common/Bannar/Bannar'
import logo from '../../assets/Avothar-black-logo.png'
import bannarImg from '../../assets/banner/main-slider-two-2.jpg'
import tourImage from '../../assets/farm/tourImage.png'
import AOS from 'aos'
// import sectionTwoImg from '../../assets/farm/avothar-bg-img-2.jpg' 
import ripped from '../../assets/farm/ripped-paper-header-1.png'
// import formVideo from '../../assets/farm/avothar-form-video.mp4'
import corporateTravelImg from '../../assets/farm/corporate-travel-farms.png'
import expectImg from '../../assets/farm/expect-in-forms.png'
import contactImg from '../../assets/farm/contact-us-farms.png'
import '../../App.css'
import '../../styles/farms.css'

const Farms = () => {

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className='farms-page bg-white'>
      <Navbar position="static" logo={logo} color='dark' buttonColor='light' navColor="black" />

      <Bannar img={bannarImg} name="Farms" attachment="fixed" />

      <section className='farm-section-1 d-flex justify-content-center align-items-center py-5' style={{ fontSize: "1.05rem" }}>
        <div className='container py-5 pt-5' style={{ width: "80%" }} data-aos="zoom-in-right" data-aos-duration="3000" >
          <h1 className='text-center'><b className='banner-font fs-1'>Looking for a unique and memorable team building activity for your corporate team?</b></h1>
          <p className='text-center fs-5' style={{lineHeight:2, wordSpacing:2, letterSpacing:1}}>Our Nature Team Events are the perfect way to bring your team together and make lasting memories. <br />
            Our team will work with you to create a customized experience that meets your needs, <br />
            whether you’re looking for a relaxing day in nature or an adrenaline-filled adventure.
          </p>
        </div>
      </section>

      <div className='ripped-paper-base' style={{
        backgroundImage: `url(${ripped})`, height: "2.6vh", backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        // transform: "rotate(180deg)",
        width: "100%",
        backgroundSize: "cover",
        position: "relative", bottom: -15,left:0
      }}></div>
      <section>
        <div className='row tour-image' style={{ backgroundColor: "#000000" }}>
          <div className='col-lg-6 p-0 '  >
            <img src={tourImage} alt="tour-image" className='w-100 ' />
          </div>
          <div className='col-lg-6 d-flex justify-content-center align-items-center ' style={{ color: "#ffffff" }}>
            <div className='w-75 p-md-5  py-5' data-aos="fade-up" data-aos-duration="3000">
              <h2 className='banner-font fs-1 '>Tour Our Farm</h2>
              <p className='' style={{fontSize:"16px", lineHeight:2, wordSpacing:2, letterSpacing:1}}>Welcome to our avocado plantation in the hills of Kodaikanal! Our farm is a nature lover’s paradise, featuring stunning views, lush greenery, and an abundance of wildlife. Whether you’re an individual looking to explore the natural beauty of the region, or a corporate group looking for a unique team building activity, we invite you to tour our farm and experience the wonders of sustainable agriculture..</p>
            </div>
          </div>
        </div>
      </section>
      <div className='ripped-paper-base' style={{
        backgroundImage: `url(${ripped})`, height: "2.6vh", backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        transform: "rotate(180deg)",
        backgroundSize: "cover",
        position: "relative", bottom: 15,left:0
      }}></div>

      <section>
        <div className="container my-4" >
          <div className="card mb-3 w-75 " data-aos="fade-right" style={{boxShadow:'rgba(14, 30, 37, 0.12) 0px 0px 23px 10px'}}>
            <div className="row g-0 align-items-center">
              <div  className="col-md-4 text-center">
                <img
                style={{width:"50%"}}
                  src={corporateTravelImg}
                  alt="Corporate Travel and Learning Programs"
                  className="img-fluid "
                />
              </div>
              <div className="col-md-8">
                <div className="card-body">
                  <p className="card-text banner-font text-start">
                    We at <b>Avothar</b> encourage corporate tours where
                    you can have a breathtaking mountain trek, explore nature,
                    and discover the strength of your soul physically & mentally.
                    Visit one of the largest avocado plantations, talk to farmers,
                    and learn about agriculture.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container my-4 d-flex justify-content-end">
          <div className="card mb-3 w-75 " data-aos="fade-left" style={{backgroundColor:"#095E4B", color:"#ffffff", boxShadow:'rgba(14, 30, 37, 0.12) 0px 0px 23px 10px'}}>
            <div className="row g-0 align-items-center">
             
              <div className="col-md-8">
                <div className="card-body">
                  <p className="card-text banner-font text-start">
                    Join us at 9 AM for an adventure-packed day! Meet our expert hike guide, trek to the waterfalls, and take a pit stop with a refreshing nature drink. Learn about local culture and farming as we walk through the lush avocado plantation, plan team-building activities and enjoy a delicious lunch outdoors.
                  </p>
                </div>
              </div>

               <div className="col-md-4 text-center">
                <img
                
                  src={expectImg}
                  alt="Corporate Travel and Learning Programs"
                  className="img-fluid rounded-4 py-2"
                  style={{width:"50%"}}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container my-4 ">
          <div className="card mb-3 w-75" data-aos="fade-right" style={{boxShadow:'rgba(14, 30, 37, 0.12) 0px 0px 23px 10px'}} >
            <div className="row g-0 align-items-center">
              <div className="col-md-4 text-center">
                <img
                  src={contactImg}
                  alt="Corporate Travel and Learning Programs"
                  className="img-fluid rounded-start "
                  style={{width:"50%"}}
                />
              </div>
              <div className="col-md-8">
                <div className="card-body banner-font">
                  <p className="card-text banner-font text-start">
                    Ready to schedule your visit to our farm? Contact us today to book your tour and experience the beauty of Kodaikanal and its avocado plantation!
                  </p>
                  <a href="https://kodaiagriorg.com/contact-us/" target='blank'><button type='button' className='btn btn-success px-4'>Click</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
      <Footer />
    </div>
  )
}

export default Farms